<template>
  <div class="finance-income">
    <div class="finance-income__filters d-flex px-3">
      <datepicker
        id="selectedStartDate"
        v-model="selectedStartDate"
        :startDate="minDateForSelect"
        :endDate="maxDateForSelect"
      ></datepicker>
      <datepicker
        id="selectedEndDate"
        v-model="selectedEndDate"
        :startDate="minDateForSelect"
        :endDate="maxDateForSelect"
        class="ml-2"
      ></datepicker>
      <select class="form-control custom-select ml-2" v-model="selectedAccountId" id="managerId">
        <option v-for="account in accounts" :key="account.name" :value="account.id" :selected="account.id === selectedAccountId">{{ account.name }}</option>
      </select>
      <select class="form-control custom-select ml-2" v-model="isPaid" id="managerId">
        <option v-for="paidOption in paidSelect" :key="paidOption.name" :value="paidOption.id" :selected="paidOption.id === isPaid">{{ paidOption.name }}</option>
      </select>
      <select class="form-control custom-select ml-2" v-if="isDirector" v-model="selectedManagerId" id="managerId">
        <option v-for="manager in managers" :key="manager.name" :value="manager.id" :selected="manager.id === selectedManagerId">{{ manager.name }}</option>
      </select>
      <button @click="loadTransactions" class="btn btn-primary mx-3" :disabled="!isCanLoadTransactions">Применить</button>
    </div>
    <form @submit.prevent class="form-inline pr-3 justify-content-between mt-4" >
      <div v-if="!isAddTransaction" @click="toggleAddTransaction">
        <button class="btn btn-outline-primary mx-3" type="button">Добавить оплату</button>
      </div>
      <form @submit.prevent v-else class="form-inline pl-3">
        <input type="text" class="form-control" placeholder="Введите сумму" @blur="updateTransactionPrice(newTransaction.price)" v-model="newTransaction.price">
        <select class="form-control custom-select ml-2" v-model="newTransaction.financeAccount">
          <option value="" selected hidden>Выберите счет</option>
          <option
              v-for="account in transactionAccounts"
              :key="account.name"
              :value="account.id"
              :selected="account.id === newTransaction.financeAccount">
              {{ account.name }}
          </option>
        </select>
        <textarea type="text" rows="1" class="form-control ml-2" placeholder="Комментарий" v-model="newTransaction.description"></textarea>
        <button type="button" @click="toggleAddTransaction" class="btn btn-outline-primary px-3 ml-2">
          <i class="fa fa-times"></i>
        </button>
        <button type="button" @click="addTransaction" :disabled="!(newTransaction.financeAccount > 0 && newTransaction.price > 0)"  class="btn btn-primary px-3 ml-2">
          <i class="fa fa-check"></i>
        </button>
      </form>
      <div v-if="transactions.length > 0" class="d-flex">
        <button @click="exportToCsv" type="button" class="btn btn-outline-primary mx-3"><i class="fa fa-download px-2"></i></button>
        <div class="input-group with-clear-icon">
          <input type="text" class="form-control" v-model="searchText">
          <i class="ico ico-close" @click="clearSearchText" v-if="searchText.length > 0"></i>
          <div class="input-group-append">
              <span class="input-group-text"><i class="fa fa-search"></i></span>
          </div>
        </div>
      </div>
    </form>
    <table class="table px-3 mt-4" v-if="transactions.length > 0">
      <thead>
        <tr>
          <th
            v-for="item in tableHeaderItems"
            :key="item.name"
            :style="{'width': item.width * 100 / tableHeaderItems.map(x=>x.width).reduce((a, b) => a + b) + '%'}"
          >
            <div class="table-th">{{ item.viewName }}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="transaction in filterdTransactions"
          :key="transaction.id"
          class="table-tr"
          :class="'table-tr--' + transaction.status"
        >
          <td
            v-for="item in tableHeaderItems"
            :key="item.name"
            :data-name="item.name"
            :data-canceled="transaction.canceled"
          >
            <div
              v-if="item.name === 'taskNumber'"
              class="td-content"
              :title=" transaction[item.name].ctid"
            >
              <router-link v-if="transaction[item.name].id" :to="`/view-task/${transaction[item.name].id}`">
                {{ transaction[item.name].ctid }}
              </router-link>
            </div>
            <div
              v-else-if="item.name === 'number'"
              class="td-content d-flex justify-content-between"
              :title="transaction['description']"
            >
              <template v-if="transaction.canceled">
                <span><del>{{ transaction[item.name] }}</del></span>
              </template>
              <template v-else>
                <span>{{ transaction[item.name] }}</span>
                <i class="ico ico-delete cursor-pointer" @click="showCancelPopup(transaction.id)"></i>
              </template>
            </div>
            <div
              v-else
              :title="transaction[item.name]"
              class="td-content"
            >{{ transaction[item.name] }}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CancelTransactionPopup from './CancelTransactionPopup.vue'
import api from '../../../api'
import moment from 'moment'
import taskStatuses from '../../../helpers/taskStatuses'
import roles from '../../../helpers/userRoles'
import { sortBy, debounce } from 'lodash'
import browser from '../../../helpers/browser'
import Papaparse from 'papaparse'
import datepicker from '../../../components/datepicker.vue'
const finishedTaskStatusId = taskStatuses.find(x => x.name === 'finished').id
const today = new Date()
const firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
const maxDate = new Date(new Date().setDate(today.getDate() + 1))
const minDate = new Date(new Date().setFullYear(today.getFullYear() - 2))
const formatNumber = (num) => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}

const getDefaultTransaction = () => {
  return {
    price: null,
    financeAccount: '',
    date: moment().format('DD.MM.YYYY'),
    description: ''
  }
}

export default {
  name: 'FinanceIncome',
  components: { datepicker },
  data () {
    return {
      users: [],
      accountsData: [],
      maxDateForSelect: maxDate,
      minDateForSelect: minDate,
      selectedStartDate: firstDateOfMonth,
      selectedEndDate: today,
      selectedManagerId: null,
      selectedAccountId: null,
      isPaid: null,
      tableHeaderItems: this.getTableHeader(),
      transactions: [],
      paidSelect: [
        { id: null, name: 'Все' },
        { id: 0, name: 'Оплач. задачи' },
        { id: 1, name: 'Не оплач. задачи' },
        { id: 2, name: 'Отмененные транз.' }
      ],
      searchText: '',
      lazySearchText: '',
      newTransaction: null,
      isAddTransaction: false
    }
  },
  computed: {
    managers () {
      const result = [{ id: null, name: 'Все пользователи' }]
      const userForSelect = this.users.filter(
        x => x.roles === roles.director || x.roles === roles.manager
      )

      userForSelect.forEach(user => {
        result.push({ id: user.id, name: `${user.firstname} ${user.lastname}` })
      })

      return result
    },
    filterdTransactions () {
      if (this.lazySearchText.length > 0) {
        return this.transactions.filter(x => x.searchString.toLowerCase().indexOf(this.lazySearchText.toLowerCase()) >= 0)
      }
      return this.transactions
    },
    accounts () {
      const result = [{ id: null, name: 'Все счета' }]

      this.accountsData.forEach(x => {
        result.push({ id: x.id, name: x.name })
      })
      return result
    },
    transactionAccounts () {
      return this.accountsData.filter(x => x.enabled)
    },
    isCanLoadTransactions () {
      return this.selectedStartDate && this.selectedEndDate && moment(this.selectedStartDate, 'DD-MM-YYYY') <= moment(this.selectedEndDate, 'DD-MM-YYYY')
    },
    isDirector () {
      return this.$store.getters.role === roles.director
    }
  },
  created () {
    Promise.all([this.loadUsers(), this.loadAccounts()])
  },
  methods: {
    async loadUsers () {
      try {
        const response = await api.get.users()
        this.users = response.data.data.users.filter(x => x.enabled)
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async loadAccounts () {
      try {
        const response = await api.get.financeAccounts()
        this.accountsData = sortBy(response.data.data.finance_accounts, 'name')
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async loadTransactions () {
      const filter = {
        start_date: moment(this.selectedStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        end_date: moment(this.selectedEndDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        account: this.selectedAccountId === null ? undefined : this.selectedAccountId,
        paid: this.isPaid === null ? undefined : this.isPaid,
        manager: this.selectedManagerId === null ? undefined : this.selectedManagerId
      }
      try {
        const response = await api.post.invoices(filter)
        this.transactions = response.data.data.finance_invoices.filter(x => +x.price >= 0).map(this.mapTransactions)
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    getStatus (task) {
      if (task.paid) {
        return 'paid'
      } else if (task.status === finishedTaskStatusId) {
        return 'notPaid'
      } else if (task.partially_paid) {
        return 'partiallyPaid'
      } else {
        return ''
      }
    },
    mapTransactions (item) {
      const result = {
        id: item.id,
        taskNumber: {
          id: item.task ? item.task.id : null,
          ctid: item.task ? item.task.ctid : null
        },
        number: item.number,
        date: moment(item.paymentTime).format('DD.MM.YYYY HH:mm'),
        calcPrice: formatNumber((+item.taskCost).toFixed(2)),
        resultPrice: formatNumber((+item.totalCost).toFixed(2)),
        paidPrice: formatNumber((+item.price).toFixed(2)),
        account: item.financeAccountName,
        manager: `${item.user.firstname} ${item.user.lastname}`,
        clinet: item.client,
        canceled: item.canceled,
        status: item.task ? this.getStatus(item.task) : 'paid',
        description: item.description
      }

      result.searchString = [
        result.taskNumber.ctid ? result.taskNumber.ctid.toString() : '',
        result.date,
        result.account,
        result.manager,
        result.clinet
      ].join(' ')

      return result
    },
    getTableHeader () {
      return [
        {
          name: 'taskNumber',
          viewName: '№',
          width: 75,
          isVisible: true
        },
        {
          name: 'number',
          viewName: '№ операции',
          width: 200,
          isVisible: true
        },
        {
          name: 'date',
          viewName: 'Дата',
          width: 150,
          isVisible: true
        },
        {
          name: 'calcPrice',
          viewName: 'Расчет',
          width: 125,
          isVisible: true
        },
        {
          name: 'resultPrice',
          viewName: 'Итог',
          width: 125,
          isVisible: true
        },
        {
          name: 'paidPrice',
          viewName: 'Оплач.',
          width: 125,
          isVisible: true
        },
        {
          name: 'account',
          viewName: 'Р/с',
          width: 150,
          isVisible: true
        },
        {
          name: 'manager',
          viewName: 'Менеджер',
          width: 150,
          isVisible: true
        },
        {
          name: 'clinet',
          viewName: 'Клиент',
          width: 150,
          isVisible: true
        }
      ]
    },
    clearSearchText () {
      this.searchText = ''
    },
    exportToCsv () {
      const headerNames = this.tableHeaderItems.map(hi => hi.viewName)
      const parsedData = this.filterdTransactions.filter(tr => !tr.canceled).map(tr => {
        return this.tableHeaderItems.map(hi => {
          switch (hi.name) {
            case 'taskNumber':
              return tr[hi.name].ctid
            case 'calcPrice':
            case 'resultPrice':
            case 'paidPrice':
              return tr[hi.name].replace('.', ',').split(' ').join('')
            default:
              return tr[hi.name]
          }
        })
      })
      const parsedContent = [headerNames, ...parsedData]
      const csvString = Papaparse.unparse(parsedContent, { quotes: true, quoteChar: '"', delimiter: ';' })
      browser.saveAsCsvFile(csvString, `Отчет финансы ${moment(this.selectedStartDate, 'DD-MM-YYYY').format('DD.MM.YY')}-${moment(this.selectedEndDate, 'DD-MM-YYYY').format('DD.MM.YY')}.csv`)
    },
    updateTransactionPrice (price) {
      this.newTransaction.price = price.replace(',', '.')
    },
    toggleAddTransaction () {
      this.newTransaction = getDefaultTransaction()
      this.isAddTransaction = !this.isAddTransaction
    },
    addTransaction () {
      const transaction = {
        price: this.newTransaction.price,
        faid: this.newTransaction.financeAccount,
        description: this.newTransaction.description
      }

      let needToRefreshTransactions = this.isCanLoadTransactions && this.transactions.length > 0
      needToRefreshTransactions = needToRefreshTransactions && moment(this.selectedEndDate, 'DD-MM-YYYY') >= moment(this.newTransaction.date, 'DD.MM.YYYY')
      needToRefreshTransactions = needToRefreshTransactions && moment(this.selectedStartDate, 'DD-MM-YYYY') <= moment(this.newTransaction.date, 'DD.MM.YYYY')

      api.post.addInvoice(transaction).then(() => {
        this.toggleAddTransaction()
        if (needToRefreshTransactions) {
          this.loadTransactions()
        }
      })
    },
    cancelTransaction (cancelInvoiceId, reason) {
      api.post.cancelInvoice(cancelInvoiceId, true, reason).then(() => {
        this.loadTransactions()
      })
    },
    showCancelPopup (cancelInvoiceId) {
      const cancelTransactionAction = (reason) => this.cancelTransaction(cancelInvoiceId, reason)
      this.$modal.show(CancelTransactionPopup, {
        cancelTransaction: cancelTransactionAction
      }, {
        height: 'auto'
      })
    }
  },
  watch: {
    searchText: debounce(function (newValue) {
      this.lazySearchText = newValue
    }, 300)
  }
}
</script>

<style lang="scss" scoped>
.finance-income {
  &__filters{
    .form-control{
      max-width: 180px;
    }
  }

  .table-tr {
    &--paid {
      td[data-name="taskNumber"] {
        .td-content {
          background-color: #28bd8b;
          color: #fff;
          a {
            color: #fff;
          }
        }
      }

      td {
        background-color: lighten($color: #28bd8b, $amount: 40);
      }
    }

    &--notPaid {
      td[data-name="taskNumber"] {
        .td-content {
          background-color: #e84c3d;
          color: #fff;
           a {
            color: #fff;
          }
        }
      }

      td {
        background-color: lighten($color: #e84c3d, $amount: 30);
      }
    }

    &--partiallyPaid {
      td[data-name="taskNumber"] {
        .td-content {
          background-color: #408fc2;
          color: #fff;
           a {
            color: #fff;
          }
        }
      }

      td {
        background-color: lighten($color: #408fc2, $amount: 30);
      }
    }
  }

  .td-content {
    display: flex;
    align-items: center;
  }

  td[data-canceled="true"] {
    .td-content {
      color: #7b7c7d;
    }
  }

  td[data-name="taskNumber"] {
    .td-content {
      justify-content: center;
      width: 46px;
      height: 48px;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 700;
      background-color: #c1c1c2;
      color: #7b7c7d;
      cursor: pointer;

      a {
        color: #7b7c7d;
        text-decoration: none;
        height: 48px;
        line-height: 48px;
        width: 100%;
        text-align: center;
      }
    }
  }

  td[data-name="number"] {
    .td-content {
      span{
        font-weight: 700;
        text-decoration: underline;
      }
    }
  }
}
</style>
